import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import LoginRegister from "../Pages/LoginRegister";
import Dashboard from "../Dashboard/Dashboard";

const AppRoutes = () => {
  return (
    <Routes>
      {/* Default Route */}
      <Route
        path="/"
        element={<Navigate to="/auth" replace />}
      />

      {/* Login/Register */}
      <Route
        path="/auth"
        element={<LoginRegister />}
      />

      {/* Future Pages */}
      {/* Dashboard */}

      <Route path="/dashboard" element={<Dashboard />} />
<Route path="/add-requirement" element={<div style={{ color: "white", textAlign: "center", marginTop: "100px", fontSize: "30px" }}>Add Requirement Page (Coming Soon)</div>} />
      {/* Requirement Table */}
      {/* <Route path="/requirements" element={<Requirements />} /> */}

      {/* 404 */}
      <Route
        path="*"
        element={
          <div
            style={{
              color: "white",
              textAlign: "center",
              marginTop: "100px",
              fontSize: "30px",
            }}
          >
            404 | Page Not Found
          </div>
        }
      />
    </Routes>
  );
};

export default AppRoutes;